// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","emptyFeed":"FU_7A","productCard":"hm_kF","relatedProductsArea":"drQg9 HdW80 YVGi7 wERSz QgIzF UXWgT"};